import Exception from "src/utils/exception";
import Constants from "src/utils/constants";
import DBOperationsComb from "src/utils/dbOperationsComb";

async function getFormFieldById(id) {
  try {
    const _fieldRes = await DBOperationsComb.getData(
      Constants.enums.TABLES_NAME_ENUM.FORM_FIELDS_TABLE,
      id,
      true
    );

    if (_fieldRes.error) {
      throw `Error fetching data of FIELD (ID: ${id}): ${_fieldRes.error}`;
    }
    return _fieldRes;
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

export default {
  getFormFieldById
};
